const _excluded = ["to"],_excluded2 = ["children", "queryParams"];function _extends() {_extends = Object.assign ? Object.assign.bind() : function (target) {for (var i = 1; i < arguments.length; i++) {var source = arguments[i];for (var key in source) {if (Object.prototype.hasOwnProperty.call(source, key)) {target[key] = source[key];}}}return target;};return _extends.apply(this, arguments);}function _objectWithoutProperties(source, excluded) {if (source == null) return {};var target = _objectWithoutPropertiesLoose(source, excluded);var key, i;if (Object.getOwnPropertySymbols) {var sourceSymbolKeys = Object.getOwnPropertySymbols(source);for (i = 0; i < sourceSymbolKeys.length; i++) {key = sourceSymbolKeys[i];if (excluded.indexOf(key) >= 0) continue;if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;target[key] = source[key];}}return target;}function _objectWithoutPropertiesLoose(source, excluded) {if (source == null) return {};var target = {};var sourceKeys = Object.keys(source);var key, i;for (i = 0; i < sourceKeys.length; i++) {key = sourceKeys[i];if (excluded.indexOf(key) >= 0) continue;target[key] = source[key];}return target;}import React from 'react';
import PropTypes from 'prop-types';
import { Link, useLocation } from 'react-router-dom';

const validProps = (props) => {
  const { to } = props,valid = _objectWithoutProperties(props, _excluded);
  return valid;
};

const CurrentLocationLink = (_ref) => {let { children, queryParams } = _ref,otherProps = _objectWithoutProperties(_ref, _excluded2);
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  Object.keys(queryParams).forEach((key) => {
    query.set(key, queryParams[key]);
  });

  query.forEach((value, key) => {
    if (value === '') {
      query.delete(key);
    }
  });

  return /*#__PURE__*/(
    React.createElement(Link, _extends({ to: `${location.pathname}?${query.toString()}` }, validProps(otherProps)),
    children
    ));

};

CurrentLocationLink.defaultProps = {
  children: '',
  queryParams: {}
};






export { CurrentLocationLink };

export default CurrentLocationLink;